import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";

const SLIDER_IMAGES = [
  "https://customer-assets.emergentagent.com/job_3fd32bcf-a697-4cc5-92fa-0d4b97cb9ef0/artifacts/zwg6bm3t_Gemini_Generated_Image_d091red091red091.png",
  "https://customer-assets.emergentagent.com/job_3fd32bcf-a697-4cc5-92fa-0d4b97cb9ef0/artifacts/648hf2f3_Gemini_Generated_Image_5bu1g05bu1g05bu1.png",
  "https://customer-assets.emergentagent.com/job_3fd32bcf-a697-4cc5-92fa-0d4b97cb9ef0/artifacts/hqq7bj62_Gemini_Generated_Image_h98ky2h98ky2h98k.png",
  "https://customer-assets.emergentagent.com/job_3fd32bcf-a697-4cc5-92fa-0d4b97cb9ef0/artifacts/ltp1ropt_Gemini_Generated_Image_8nran38nran38nra.png"
];

export const SloganSliderSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { language } = useLanguage();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % SLIDER_IMAGES.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 md:py-28 bg-[#FAF7F2] scroll-mt-20" data-testid="slogan-slider-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <div className="text-center lg:text-right order-2 lg:order-1">
            <h2 className="font-['Heebo'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2C2C] leading-tight mb-6">
              {language === 'he' ? (
                <>
                  כל צלקת מספרת סיפור,
                  <br />
                  <span className="text-[#C4956A]">אבל היא לא חייבת להגדיר אותך.</span>
                </>
              ) : (
                <>
                  Every scar tells a story,
                  <br />
                  <span className="text-[#C4956A]">but it doesn't have to define you.</span>
                </>
              )}
            </h2>
            <p className="text-lg md:text-xl text-[#2C2C2C]/70 max-w-xl mx-auto lg:mx-0 lg:mr-0">
              {language === 'he' ? (
                <>
                  הצלקת לא חייבת להיות חלק ממך לתמיד.
                  <br />
                  מזל | 40 שנות מומחיות פרא-רפואית בצלקות מורכבות.
                </>
              ) : (
                <>Mazal — Where paramedical mastery meets the art of transformation.</>
              )}
            </p>
          </div>

          <div className="order-1 lg:order-2 flex justify-center lg:justify-start">
            <div className="relative w-full max-w-lg">
              <div className="relative rounded-2xl shadow-2xl overflow-hidden aspect-square bg-[#E8DDD0]">
                <AnimatePresence mode="wait">
                  <motion.img
                    key={currentIndex}
                    src={SLIDER_IMAGES[currentIndex]}
                    alt={language === 'he' ? "לקוחה מרוצה בקליניקה" : "Happy client at clinic"}
                    className="w-full h-full object-cover"
                    initial={{ opacity: 0, scale: 1.05 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.7 }}
                    loading="lazy"
                    decoding="async"
                    width="512"
                    height="512"
                  />
                </AnimatePresence>
                <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
              </div>
              <div className="flex justify-center gap-2 mt-4">
                {SLIDER_IMAGES.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentIndex(idx)}
                    className={`w-2.5 h-2.5 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#C4956A] focus:ring-offset-2 ${
                      idx === currentIndex ? 'bg-[#C4956A] w-8' : 'bg-[#C4956A]/30 hover:bg-[#C4956A]/50'
                    }`}
                    aria-label={language === 'he' ? `עבור לתמונה ${idx + 1} מתוך ${SLIDER_IMAGES.length}` : `Go to slide ${idx + 1} of ${SLIDER_IMAGES.length}`}
                    aria-current={idx === currentIndex ? 'true' : 'false'}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
